<template>
  <div class="card card-white h-100 d-flex flex-column">
    <!-- Image -->
    <div class="img-wrapper">
      <router-link :to="product.user_id == user.id
        ? { name: 'ProductManagement', params: { id: product.id } }
        : { name: 'productDetails', params: { id: product.id } }" class="image-link"
        @click.native="handleProductClick">
        <img :src="imageUrl" alt="Product image" class="product-img" />
      </router-link>

      <!-- <add-to-cart-button :product="product" /> -->
      <!-- 🚀 Boost Icon -->
      <div v-if="urgent_ad" class="boost-badge" :class="boostClass(urgent_ad)">
        {{ $t(`ecommerce.product.${urgent_ad.type}`) }}
      </div>
      <!-- ❤️ Favorite Button -->
      <button v-if="showFavorites" class="btn-favorite" @click.stop="toggleFavorite" :class="{ 'favorited': favorited }"
        :title="favorited ? 'Remove from favorites' : 'Add to favorites'">
        <span :class="['mdi', favorited ? 'mdi-heart' : 'mdi-heart-outline']"></span>
        <span class="favorite-count">{{ favoritesCount }}</span>
      </button>
    </div>

    <!-- Card Body -->
    <div class="card-body card-white flex-grow-1 d-flex flex-column justify-content-between text-decoration-none">
      <div>
        <div class="d-flex flex-column mb-2">
          <span v-if="priorityBoost" class="text-danger">
            {{ $t(`ecommerce.product.${priorityBoost.type}`) }}
          </span>
          <span class="text-dark name">
            {{ product.name.length > 30 ? product.name.substring(0, 30) + '...' : product.name }}
          </span>

          <!-- Price -->
          <span class="font-weight-bold text-dark">
            {{ displayPrice }}
            <AlgerianPriceReaderFR v-if="price_lang == 'fr'" :price="ReadingPrice" />
            <AlgerianPriceReader v-else :price="ReadingPrice" />
          </span>
        </div>

        <span :class="{
          'color-green': product.has_been_sold === 1,
          'color-red': product.has_been_sold === 0
        }">
          {{ productStatus }}
        </span>

        <!-- Timer -->
        <span v-if="product.sales_type === 'auction'" class="d-flex align-items-center bid_timer text-wrap">{{
          product.bids?.length }} {{ $t('ecommerce.bids') }}
          <TimerSimpleLong :isLong="false" v-if="isActiveAuction" class="ml-2" :timeLeft=product.time_left
            :deadline="product.validated || 'Null'" :duration="product.duration"
            :class="product.time_left > 60 * 60 * 24 ? 'text-dark' : 'text-danger'" />
        </span>

        <!-- Description -->
        <p v-if="showDescription" class="card-text mb-1 mt-1 p-text-limit">
          {{ product.description.length > 30 ? product.description.substring(0, 30) + '...' : product.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AlgerianPriceReaderFR from './AlgerianPriceReaderFR.vue';
import AlgerianPriceReader from './AlgerianPriceReader.vue';
import TimerSimpleLong from './TimerSimpleLong.vue';
import config from '@/config';
import Cookies from 'js-cookie'
import helper from '@/services/helper';
// import AddToCartButton from '../cart/AddToCartButton.vue';

export default {
  components: {
    TimerSimpleLong,
    AlgerianPriceReader,
    AlgerianPriceReaderFR,
    // AddToCartButton,
  },
  props: {
    product: { type: Object, required: true },
    showFavorites: { type: Boolean, default: true },
    showDescription: { type: Boolean, default: true },
  },

  data() {
    return {
      price_lang: Cookies.get('price_lang')||'ar',
      storageUrl: config.storageUrl,
      favorited: this.product.is_favorited||false,
      favoritesCount: this.product.favorites_count||0,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
    imageUrl() {
      const pics=this.product.pictures;
      return this.storageUrl+(Array.isArray(pics)? pics[0]:pics);
    },
    ReadingPrice() {
      const p=this.product;

      if (p.sales_type==='fixed') {
        return p.fixed_price;
      }

      if (Array.isArray(p.bids)&&p.bids.length>0) {
        return p.bids[0].price;
      }

      return p.starting_price;
    },
    displayPrice() {
      const p=this.product;

      if (p.sales_type==='fixed') {
        return this.$t('product.fixedPrice', {
          price: this.$options.filters.currency(p.fixed_price, ' DA', 0, {
            symbolOnLeft: false
          })
        });
      }

      if (Array.isArray(p.bids)&&p.bids.length>0) {
        return this.$t('product.currentBid', {
          price: this.$options.filters.currency(p.bids[0].price, ' DA', 0, {
            symbolOnLeft: false
          })
        });
      }

      return this.$t('product.startingPrice', {
        price: this.$options.filters.currency(p.starting_price, ' DA', 0, {
          symbolOnLeft: false
        })
      });
    },

    canMakeOffer() {
      const p=this.product;
      return p.accept_offer===1&&p.has_been_sold===0&&p.auction_status===1;
    },
    productStatus() {
      return this.product.has_been_sold===1
        ? this.$t('sentence.productSold')
        :this.product.time_left<0? this.$t('general.ended'):'';
    },
    isActiveAuction() {
      const p=this.product;
      return p.sales_type==='auction'&&p.time_left>0;
    },
    priorityBoost: helper.priorityBoost,
    urgent_ad: helper.urgent_ad,
  },
  methods: {
    boostClass: helper.boostClass,
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    // NEW: Emit event when product is clicked
    handleProductClick() {
      this.$emit('product-clicked', this.product);
    },

    async toggleFavorite() {
      try {
        if (!this.isLoggedIn()) {
          this.$router.push('/login');
          return;
        }
        const res=await this.$axios.post(`favorites/toggle/${this.product.id}`);
        const newStatus=res.data.data.status;
        console.log(res.data.data.status);

        this.favorited=newStatus;

        this.favoritesCount=newStatus
          ? this.favoritesCount+1
          :Math.max(0, this.favoritesCount-1);

      } catch (error) {
        console.error('Failed to toggle favorite:', error);
        this.$toast?.error('Failed to update favorite');
      }
    },
  },
};
</script>

<style scoped>
.card {
  min-height: 420px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  overflow: hidden;
}

.p-text-limit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.img-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
}

.image-link {
  display: block;
  width: 100%;
  height: 100%;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

/* ❤️ Favorite Button */
.btn-favorite {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 15%;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-favorite:hover {
  background: rgba(255, 255, 255, 0.35);
}

.btn-favorite .mdi {
  font-size: 20px;
  color: var(--gray-500);
  transition: all 0.2s ease;
  line-height: 1;
}

.btn-favorite.favorited {
  background: rgba(220, 53, 69, 0.9);
}

.btn-favorite.favorited:hover {
  background: rgba(220, 53, 69, 1);
}

.btn-favorite.favorited .mdi {
  color: white;
}

.favorite-count {
  color: var(--gray-500);
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  margin: 0;
}

.btn-favorite.favorited .favorite-count {
  color: white;
}

.btn-favorite:hover .mdi {
  transform: scale(1.1);
}

span.name {
  font-size: 14pt;
  font-weight: 400;
}

.bid_timer {
  font-size: 10pt;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  50% {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }
}
</style>